const genderMap = {
    '1': "H",
    '2': "F",
    '3': "NC"
};
const genderMapEmoji = {
    '1': "♂️",
    '2': "♀️",
    '3': "⚧️"
};
const genderMapFontAwesome = {
    '1': "mars",
    '2': "venus",
    '3': "mars-and-venus"
};
export const genderHelper = {
    format: (gender) => genderMap[gender]
};
export const genderHelperEmoji = {
    format: (gender) => genderMapEmoji[gender]
};
export const genderHelperFontAwesome = {
    format: (gender) => genderMapFontAwesome[gender]
};
//# sourceMappingURL=genderHelper.js.map